"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectionControls = exports.containerClass = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_structures_1 = require("@tableau/data-structures");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
const MultiSelectionControls_1 = require("./MultiSelectionControls");
const SmallInlineFadeInSpinner_1 = require("./SmallInlineFadeInSpinner");
exports.containerClass = (0, vizportalclient_common_components_1.cssClass)('SingleSelectionControls_container', {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
});
const dividerClass = (0, vizportalclient_common_components_1.cssClass)('SingleSelectionControls_divider', Object.assign(Object.assign({}, MultiSelectionControls_1.margin), { display: 'inline-block', height: 20, width: 1, backgroundColor: widgets_1.TabStyles.Colors.L3 }));
const textClass = (0, vizportalclient_common_components_1.cssClass)('SingleSelectionControls_text', Object.assign(Object.assign({}, MultiSelectionControls_1.margin), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default, color: widgets_1.TabStyles.Colors.L9 }));
const clearAndCountClass = (0, vizportalclient_common_components_1.cssClass)('SingleSelectionControls_clearAndCount', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
class SingleSelectionControls extends react_1.default.PureComponent {
    render() {
        return (react_1.default.createElement(client_1.ApolloConsumer, null, client => react_1.default.createElement(SingleSelectionControlsInternal, Object.assign({}, this.props, { client: client }))));
    }
}
exports.SingleSelectionControls = SingleSelectionControls;
class SingleSelectionControlsInternal extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.memoizedGetKeySetSize = (0, reselect_1.defaultMemoize)(data_structures_1.getKeySetSize);
        this.state = {
            selecting: false,
        };
    }
    render() {
        return (react_1.default.createElement("span", { className: clearAndCountClass }, this.renderClearAndCountOrSelecting()));
    }
    renderClearAndCountOrSelecting() {
        if (this.state.selecting) {
            return react_1.default.createElement(SmallInlineFadeInSpinner_1.SmallInlineFadeInSpinner, null);
        }
        else {
            const selectedItemCount = this.memoizedGetKeySetSize(this.props.selectedKeys);
            if (selectedItemCount > 0) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, handleClick: this.props.clearSelection, style: MultiSelectionControls_1.buttonStyle, testId: 'clear' }, catalog_messages_1.Messages.Clear()),
                    react_1.default.createElement("span", { className: dividerClass }),
                    react_1.default.createElement("span", { className: textClass }, catalog_messages_1.Messages.XItemsSelected({
                        COUNT: selectedItemCount,
                        COUNT_LOC: catalog_messages_1.Formatters.formatCount(selectedItemCount),
                    }))));
            }
            else {
                return null;
            }
        }
    }
}
//# sourceMappingURL=SingleSelectionControls.js.map